<template>
  <div class="menu" @mouseleave="mouseOver(page)">
    <!-- <ul class="mainmenu">
			<li v-for="cat in menuItems" v-bind:key="cat.index">
				<a :href="cat.main.link" class="menu-item" :id="'menu_' + cat.main.text" @mouseover="mouseOver(cat.main.text)">
					{{ cat.main.text }}</a>
			</li>
		</ul> -->
    <!-- <ul id="submenu" class="submenu">
			<li v-for="item in currentitems" v-bind:key="item.index">
				<a :href="item.link">{{ item.text }}</a>
			</li>
		</ul> -->
    <!-- <ul class="mainmenu">
			<li v-for="cat in menuItems" v-bind:key="cat.index" @mouseover="mouseOver(cat.main.text)">
				<router-link :to="cat.main.link" class="menu-item" :id="'menu_' + cat.main.text" >
					{{ cat.main.text }}</router-link>
			</li>
		</ul>
		<ul id="submenu" class="submenu">
			<li v-for="item in currentitems" v-bind:key="item.index">
				<router-link :to="item.link">{{ item.text }}</router-link>
			</li>
		</ul> -->
    <br />
    <br />
  </div>
</template>

<script>
import { menuItems } from "../recourses/menu";

export default {
  name: "menu",
  data() {
    return {
      menuItems: {},
      currentitems: []
    };
  },
  computed: {},
  methods: {
    highlightMenuItem(menuItem, solo) {
      document.getElementById(menuItem).style.cssText =
        "box-shadow: inset 0px 1px 1px #2D2F31; background-color: #BADAFA;";
      if (solo) {
        document.getElementById(menuItem).style.cssText +=
          "border-radius: 5px;";
        document.getElementById("submenu").style.cssText = "background: none;";
      } else {
        document.getElementById("submenu").style.cssText =
          "background: #BADAFA;";
      }
    },
    mouseOver(cat) {
      for (let element of document.getElementsByClassName("menu-item")) {
        element.style.cssText =
          "box-shadow: none; background-color: none; border-radius: 5px 5px 0 0;";
      }
      switch (cat) {
        case "Home":
          this.currentitems = this.menuItems.demo.sub;
          this.highlightMenuItem("menu_Home", true);
          break;
        case "Talentenspel":
          this.currentitems = this.menuItems.talentenspel.sub;
          this.highlightMenuItem("menu_Talentenspel", true);
          break;
        case "Talentenspel Begeleiding":
          this.currentitems = this.menuItems.coaching.sub;
          this.highlightMenuItem("menu_Talentenspel Begeleiding", true);
          break;
        case "Game of Gifts":
          this.currentitems = this.menuItems.gameofgifts.sub;
          this.highlightMenuItem("menu_Game of Gifts", true);
          break;
        case "Scholing":
          this.currentitems = this.menuItems.scholing.sub;
          this.highlightMenuItem("menu_Scholing");
          break;
        case "Bedrijven":
          this.currentitems = this.menuItems.bedrijven.sub;
          this.highlightMenuItem("menu_Bedrijven", true);
          break;
        case "Agenda":
          this.currentitems = this.menuItems.agenda.sub;
          this.highlightMenuItem("menu_Agenda", true);
          break;
        case "Contact":
          this.currentitems = this.menuItems.contact.sub;
          this.highlightMenuItem("menu_Contact", true);
          break;
      }
    }
  },
  props: ["page"],
  beforeMount() {
    this.menuItems = menuItems;
  },
  mounted() {
    this.mouseOver(this.page);
  }
};
</script>

<style lang="less">
@import "../styles/styles.less";

.menu {
  margin-bottom: 5px;
}

.menu a {
  text-decoration: none;
  display: block;
  color: @gray-4;
}

.menu li {
  display: inline-block;
  margin: 0;
}

.mainmenu,
.submenu {
  text-align: center;
  list-style: none;
}

.mainmenu a {
  font-size: 14pt;
  font-weight: normal;
  border-radius: 5px 5px 0 0;
  padding: 10px;
}

.submenu {
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  width: @container-width;
  background-color: @light-blue-1;
  height: 36px;
}

.submenu a {
  padding: 10px 15px 2px 15px;
  font-size: 11pt;
}
.submenu a:hover {
  border-bottom: 2px solid @blue-3;
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue